class ProductMOQ extends HTMLElement {
  constructor(){
    super();

    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('qty-plus')) {
        this.updateQuantity(1);
      }

      if (e.target.classList.contains('qty-minus')) {
        this.updateQuantity(-1);
      }

      if (e.target.classList.contains('faux-button')) {
        this.emulateAddToCart();
      }
    });
  }

  updateQuantity(amount) {
    const container = this.querySelector('.product-quantity');
    const text = container.querySelector('.button__text');
    let { min, inventory } = container.dataset;

    const form = this.nextElementSibling;
    const qtyEl = form?.elements['quantity'];
    if (!qtyEl || !min) return;

    const oldValue = +qtyEl.value;
    const newValue = oldValue + amount;

    if (newValue < +min) {
      return;
    }

    inventory = JSON.parse(inventory);
    if (inventory && inventory.quantity > 0) {
      if (inventory.management === 'shopify' && inventory.policy === 'deny') {
        if (newValue > +inventory.quantity) {
          return;
        }
      }
    }

    qtyEl.value = newValue;

    if (text) {
      text.innerText = `Add ${newValue}`;
    }
  }

  emulateAddToCart() {
    const container = this.querySelector('.faux-button');
    const productForm = this.closest('product-form');
    const form = this.nextElementSibling;
    const button = form?.elements['add'];
    if (!container || !productForm || !button) return;

    container.classList.add('working'); // Adds loading anim
    button.click();

    productForm.addEventListener('add-to-cart', (e) => {
      container.classList.remove('working'); // Remove loading anim
    })
  }
}
if (!customElements.get('product-moq')){
  customElements.define('product-moq', ProductMOQ);
}